import { render, staticRenderFns } from "./CommentsPreviewBodyRecipients.vue?vue&type=template&id=516f0944&scoped=true&"
import script from "./CommentsPreviewBodyRecipients.vue?vue&type=script&lang=js&"
export * from "./CommentsPreviewBodyRecipients.vue?vue&type=script&lang=js&"
import style0 from "./CommentsPreviewBodyRecipients.vue?vue&type=style&index=0&id=516f0944&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516f0944",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('516f0944')) {
      api.createRecord('516f0944', component.options)
    } else {
      api.reload('516f0944', component.options)
    }
    module.hot.accept("./CommentsPreviewBodyRecipients.vue?vue&type=template&id=516f0944&scoped=true&", function () {
      api.rerender('516f0944', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/submissions/CommentsPreviewBodyRecipients.vue"
export default component.exports